import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'StoreModel';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const mapStateToProps = (state: RootState) => ({
  literals: state.literals,
});

interface Props extends ReturnType<typeof mapStateToProps> {}

const NotFound: React.FC<Props> = ({ literals }) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>{literals.global_page_not_found}</title>
      </Helmet>
      <Container>
        <h2>{literals.global_wrong_page} 🤪</h2>
        <h3>{literals.global_page_does_not_exist}</h3>
      </Container>
    </React.Fragment>
  );
};

export default connect(mapStateToProps, {})(NotFound);
